import { render, staticRenderFns } from "./SlotFilters.vue?vue&type=template&id=5f0dc086"
import script from "./SlotFilters.vue?vue&type=script&lang=js"
export * from "./SlotFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports